import { useEffect } from 'react'
import PropTypes from 'prop-types'

const AuthenticationComponent = props => {
  useEffect(() => {
    props.getTokenValidate()
  }, [])

  if (props.retrieving) {
    return null
  }

  return props.children
}

AuthenticationComponent.propTypes = {
  getTokenValidate: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  retrieving: PropTypes.bool
}

AuthenticationComponent.defaultProps = {
  shouldLoadTokenValidate: true
}

export default AuthenticationComponent
